var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Col } from '../index';
import Item from './Item';
import { Droppable } from 'react-beautiful-dnd';
function Column(props) {
    var col = props.col, editMode = props.editMode;
    return (_jsxs(Col, __assign({ sm: 12, lg: 6, style: { paddingLeft: 0, paddingRight: 0 } }, { children: [_jsx("h5", __assign({ className: 'tol-dnd-column-title' }, { children: col.id })), _jsx(Droppable, __assign({ droppableId: col.id }, { children: function (provided, snapshot) { return (_jsx("div", __assign({ className: snapshot.isDraggingOver ? 'tol-dnd-column-drop' : 'tol-dnd-column' }, { children: _jsxs("div", __assign({}, provided.droppableProps, { ref: provided.innerRef }, { children: [col.list.map(function (item, index) { return (_jsx(Item, { item: item, index: index, editMode: editMode }, item.id)); }), provided.placeholder] })) }))); } }))] }), "tol-widget-".concat(col.id)));
}
export default Column;
